import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, Input } from '@angular/core';
import { TENANTSINTERFACE } from '@fitness-force/models';
import { Store } from '@ngrx/store';
import { TENANTS_INFO } from 'apps/ff-frontend/src/app/state/app.state';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';

@Component({
  selector: 'fitness-force-tenant-name',
  templateUrl: './tenant-name.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule]
})
export class TenantNameComponent implements OnInit {
  @Input() columnData = new BehaviorSubject(null);
  @Input() additionData = new BehaviorSubject(null);
  getAccessTenantList$: any;
  allTenants: any;
  constructor(private store: Store) { }

  ngOnInit(): void {
    this.getAccessTenantList$ = this.store.select(TENANTS_INFO);
    this.getAccessTenantList$.subscribe((tenant: TENANTSINTERFACE) => {
      this.allTenants = tenant.accessed_tenant;
    });
  }

  getTenant(tenantId:number)
  {
    return this.allTenants.find((o: { id: number; }) => o.id == tenantId)!;
  }

}
